import { getRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function getAllTripAddressesRequest() {
	let url = tripAddresses.getAllPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
